import { c as _c } from "react/compiler-runtime";
import Close from "@mui/icons-material/Close";
import { alpha, Box, Button, Dialog, DialogActions, DialogContent, type DialogProps, DialogTitle, IconButton, Typography, useTheme } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { type OrbitControls as ThreeOrbitControls } from "three-stdlib";
import { useMobileLayout } from "#/shared/hooks/useMobileLayout";
import { PythonLogoView } from "#/shared/ui/molecules/PythonLogoView";
import { GITHUB_URL } from "#/constants";
export const PYTHON_SUPPORT_MODAL_ID = "python-support";
export type PythonSupportModalProps = DialogProps & {
  onClose: () => void;
};
export const PythonSupportModal: React.FC<PythonSupportModalProps> = t0 => {
  const $ = _c(45);
  let onClose;
  let props;
  if ($[0] !== t0) {
    ({
      onClose,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onClose;
    $[2] = props;
  } else {
    onClose = $[1];
    props = $[2];
  }
  const theme = useTheme();
  const isMobile = useMobileLayout();
  const controlsRef = useRef(null);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      const azimuthalAngle = (window.innerWidth - event.clientX) / window.innerWidth * Math.PI - Math.PI / 2;
      const polarAngle = (window.innerHeight - event.clientY) / window.innerHeight * Math.PI;
      if (controlsRef.current) {
        controlsRef.current.setAzimuthalAngle(azimuthalAngle);
        controlsRef.current.setPolarAngle(polarAngle);
      }
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleMouseMove = t1;
  let t2;
  let t3;
  if ($[4] !== isMobile) {
    t2 = () => {
      if (!controlsRef.current || isMobile) {
        return;
      }
      controlsRef.current.setAzimuthalAngle(Math.PI / 7);
      controlsRef.current.setPolarAngle(Math.PI / 1.5);
    };
    t3 = [isMobile];
    $[4] = isMobile;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  const t4 = isMobile ? 0 : "15vh";
  let t5;
  if ($[7] !== t4) {
    t5 = {
      paper: {
        sx: {
          overflow: "visible",
          marginTop: t4
        }
      }
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = isMobile ? "-32px" : "-6%";
  const t7 = isMobile ? 470 : "70%";
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = {
      position: "fixed",
      top: t6,
      left: 0,
      width: "100%",
      height: t7
    };
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Box sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      height: "100%",
      aspectRatio: "1/1",
      transform: "translate(-50%, -50%) translate(-70px, -50px)",
      background: "radial-gradient(circle, #3675A955 0%, transparent 60%)",
      animation: "fade-in 0.5s ease-in-out"
    }} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Box sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      height: "100%",
      aspectRatio: "1/1",
      transform: "translate(-50%, -50%) translate(70px, 50px)",
      background: "radial-gradient(circle, #FFD54F22 0%, transparent 60%)",
      animation: "fade-in 0.5s ease-in-out"
    }} />;
    t11 = <PythonLogoView controlsRef={controlsRef} />;
    $[13] = t10;
    $[14] = t11;
  } else {
    t10 = $[13];
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t8) {
    t12 = <Box sx={t8}>{t9}{t10}{t11}</Box>;
    $[15] = t8;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <DialogTitle>Python Support</DialogTitle>;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== theme.palette.grey[500]) {
    t14 = {
      position: "absolute",
      right: 8,
      top: 8,
      color: theme.palette.grey[500]
    };
    $[18] = theme.palette.grey[500];
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Close />;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== onClose || $[22] !== t14) {
    t16 = <IconButton aria-label="close" onClick={onClose} sx={t14}>{t15}</IconButton>;
    $[21] = onClose;
    $[22] = t14;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      "&::-webkit-scrollbar": {
        zIndex: 10
      }
    };
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  const t18 = isMobile ? 32 : 8;
  let t19;
  if ($[25] !== theme.palette.primary.light) {
    t19 = alpha(theme.palette.primary.light, 0.1);
    $[25] = theme.palette.primary.light;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t18 || $[28] !== t19) {
    t20 = {
      mt: t18,
      p: 2,
      backgroundColor: t19,
      backdropFilter: "blur(10px)",
      borderRadius: 2,
      border: "1px solid #ffffff10",
      maxHeight: "45vh",
      overflowY: "auto"
    };
    $[27] = t18;
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  const t21 = isMobile ? "Open this page on desktop to run Python code!" : "Could not connect to the local Python runner";
  let t22;
  if ($[30] !== t21) {
    t22 = <Typography variant="h4" textAlign="center" gutterBottom={true}>{t21}</Typography>;
    $[30] = t21;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  let t24;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Typography gutterBottom={true}>You are currently using the legacy server execution mode (NEXT_PUBLIC_PYTHON_EXEC_MODE=server). This requires a local dStruct runner process on port 8085.</Typography>;
    t24 = <Typography gutterBottom={true}>Tip: switch to the default in-browser Pyodide mode by removing NEXT_PUBLIC_PYTHON_EXEC_MODE from your environment. Python code will then execute directly in the browser via a Web Worker with no server required.</Typography>;
    $[32] = t23;
    $[33] = t24;
  } else {
    t23 = $[32];
    t24 = $[33];
  }
  let t25;
  if ($[34] !== t20 || $[35] !== t22) {
    t25 = <DialogContent dividers={true} sx={t17}><Box sx={t20}>{t22}{t23}{t24}</Box></DialogContent>;
    $[34] = t20;
    $[35] = t22;
    $[36] = t25;
  } else {
    t25 = $[36];
  }
  let t26;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <DialogActions><Button href={GITHUB_URL} target="_blank">Contribute</Button></DialogActions>;
    $[37] = t26;
  } else {
    t26 = $[37];
  }
  let t27;
  if ($[38] !== onClose || $[39] !== props || $[40] !== t12 || $[41] !== t16 || $[42] !== t25 || $[43] !== t5) {
    t27 = <Dialog maxWidth="lg" onClose={onClose} slotProps={t5} onMouseMove={handleMouseMove} {...props}>{t12}{t13}{t16}{t25}{t26}</Dialog>;
    $[38] = onClose;
    $[39] = props;
    $[40] = t12;
    $[41] = t16;
    $[42] = t25;
    $[43] = t5;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  return t27;
};